export const removeWordFromString = (input: string, wordToRemove: string, limit?: number): string => {
  // Delete searched words and clean up redundant spaces
  const newInput = input.replace(new RegExp(wordToRemove, 'gi'), '').replace(/\s+/g, ' ').trim();

  if (limit) {
    return newInput.length > limit ? newInput?.slice(0, limit) + '...' : newInput;
  }

  return newInput;
};
